import { gql } from 'urql';

export const REPARTO_FIELDS = gql`
  fragment RepartoFields on Reparto {
    id
    sucursal_id
    fecha
    linea_id
    chofer_id
    fletero_id
    unidad_id
    estado
    total_guias
    total_kilos
    total_valor_declarado
    total_contrarrembolso
    total_flete
    observaciones
    created_at
    updated_at
  }
`;

export const REPARTOS_BY_SUCURSAL = gql`
  ${REPARTO_FIELDS}
  query RepartosBySucursal($sucursalId: Int!, $estado: RepartoEstado, $fechaDesde: String, $fechaHasta: String) {
    repartosBySucursal(sucursalId: $sucursalId, estado: $estado, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta) {
      ...RepartoFields
    }
  }
`;

export const MONITOR_REPARTOS = gql`
  query MonitorRepartos($sucursalId: Int!) {
    monitorRepartos(sucursalId: $sucursalId) {
      abiertos
      en_rendicion
      liquidados
      total_cr_pendiente
    }
  }
`;

export const ESTADISTICAS_REPARTOS = gql`
  query EstadisticasRepartos($sucursalId: Int!, $fechaDesde: String, $fechaHasta: String) {
    estadisticasRepartos(sucursalId: $sucursalId, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta) {
      id
      fecha
      chofer_id
      estado
      total_guias
      entregadas
      retenidas
      no_entregadas
      reprogramadas
      pendientes
      contrarreembolso_pendiente
    }
  }
`;

export const REPARTO_DETALLE = gql`
  ${REPARTO_FIELDS}
  query RepartoDetalle($id: Int!) {
    repartoDetalle(id: $id) {
      ...RepartoFields
      guias { id guia_id estado novedad fecha_entrega receptor numero_guia destinatario domicilio localidad bultos contrarreembolso }
      rendiciones { id tipo monto_declarado monto_rendido diferencia estado observaciones created_at }
      liquidaciones { id tipo total_flete total_adicionales total_descuentos total_final estado created_at }
    }
  }
`;

export const CREAR_REPARTO = gql`mutation CrearReparto($input: CrearRepartoInput!) { crearReparto(input: $input) { id } }`;
export const ASIGNAR_GUIAS_REPARTO = gql`mutation AsignarGuiasAReparto($repartoId: Int!, $guiaIds: [Int!]!) { asignarGuiasAReparto(repartoId: $repartoId, guiaIds: $guiaIds) { id total_guias total_flete total_contrarrembolso total_kilos } }`;
export const REGISTRAR_NOVEDAD = gql`mutation RegistrarNovedad($repartoGuiaId: Int!, $novedad: String!, $estado: RepartoGuiaEstado!) { registrarNovedad(repartoGuiaId: $repartoGuiaId, novedad: $novedad, estado: $estado) { id estado novedad } }`;
export const INICIAR_REPARTO = gql`mutation IniciarReparto($id: Int!) { iniciarReparto(id: $id) { id estado } }`;
export const REGISTRAR_ENTREGA = gql`mutation RegistrarEntrega($repartoGuiaId: Int!, $receptor: String!, $observaciones: String) { registrarEntrega(repartoGuiaId: $repartoGuiaId, receptor: $receptor, observaciones: $observaciones) { id estado receptor novedad fecha_entrega } }`;
export const REGISTRAR_RETENCION = gql`mutation RegistrarRetencion($repartoGuiaId: Int!, $motivo: String!) { registrarRetencion(repartoGuiaId: $repartoGuiaId, motivo: $motivo) { id estado novedad } }`;
export const CERRAR_REPARTO = gql`mutation CerrarReparto($id: Int!) { cerrarReparto(id: $id) { id estado } }`;
export const REGISTRAR_RENDICION = gql`mutation RegistrarRendicion($input: RegistrarRendicionInput!) { registrarRendicion(input: $input) { id tipo diferencia estado } }`;
export const APROBAR_RENDICION = gql`mutation AprobarRendicion($id: Int!) { aprobarRendicion(id: $id) { id estado } }`;
export const GENERAR_LIQUIDACION = gql`mutation GenerarLiquidacion($input: GenerarLiquidacionInput!) { generarLiquidacion(input: $input) { id total_final estado tipo } }`;
export const MARCAR_LIQUIDACION_PAGADA = gql`mutation MarcarLiquidacionPagada($id: Int!) { marcarLiquidacionPagada(id: $id) { id estado } }`;
